import {PerformanceChartSection} from '@/features/quote/components/performance-chart/PerformanceChartSection'
import {StyledQuotePageWrapper} from '@/features/quote/components/summary-quote/style.ts'
import {SummaryQuote} from '@/features/quote/components/summary-quote/SummaryQuote.tsx'
import {ComponentsQuote} from '@/features/quote/components/components-quote/ComponentsQuote.tsx'
import {FinancialImpact} from '@/features/quote/components/financial-impact/FinancialImpact'
import {SavingQuote} from '@/features/quote/components/saving-quote/SavingQuote.tsx'
import {EnvironmentalBenefits} from '@/features/quote/components/environmental-benefits-section/EnvironmentalBenefits.tsx'
import {useGetQuote} from '@/features/quote/queries/useGetQuote'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useEffect} from 'react'
import {errorHandler} from '@/utilities/helpers'
import {useParams} from 'react-router-dom'
import {useGetQuoteCalculations} from '@/features/quote/queries/useGetQuoteCalculations'
import {OperationSystem} from '@/features/quote/components/operation-system/OperationSystem.tsx'
import {FooterSection} from '@/features/quote/components/footer-section/FooterSection'
import {ProductsSection} from '@/features/quote/components/products-section/ProductsSection'

export const Component = () => {
    const {quoteId} = useParams()

    const {
        data: quoteData,
        isLoading: isQuoteLoading,
        error: quoteError,
        isError: isQuoteError
    } = useGetQuote({quoteId})

    const {
        data: quoteCalculationsData,
        isLoading: isQuoteCalculationLoading,
        error: quoteCalculationError,
        isError: isQuoteCalculationError
    } = useGetQuoteCalculations({quoteId})

    useEffect(() => {
        if (isQuoteError || isQuoteCalculationError) {
            errorHandler({error: quoteError || quoteCalculationError})
        }
    }, [isQuoteError, isQuoteCalculationError])

    if (isQuoteLoading || isQuoteCalculationLoading) return <Spinner />

    return (
        <>
            {quoteData && quoteCalculationsData && (
                <StyledQuotePageWrapper>
                    <SummaryQuote
                        quoteData={quoteData}
                        systemSize={quoteCalculationsData?.systemSize}
                        estimatedAnnualSavings={quoteCalculationsData?.estimatedAnnualSavings}
                    />

                    <ComponentsQuote quoteData={quoteData} quoteCalculationsData={quoteCalculationsData} />
                    <PerformanceChartSection quoteCalculationsData={quoteCalculationsData} />
                    <SavingQuote quoteCalculationsData={quoteCalculationsData} />
                    <FinancialImpact quoteCalculationsData={quoteCalculationsData} />
                    <EnvironmentalBenefits quoteCalculationsData={quoteCalculationsData} />
                    <OperationSystem quoteCalculationsData={quoteCalculationsData} quoteData={quoteData} />
                    <ProductsSection quoteData={quoteData} />

                    <FooterSection />
                </StyledQuotePageWrapper>
            )}
        </>
    )
}

Component.displayName = 'Quote'
